import "@fortawesome/fontawesome-pro/css/all.css";
import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#FF5722",
        secondary: "#BDBDBD",
        tertiary: "#EEEEEE",
        accent: "#FF5722",
        background: "#FFFFFF",
        success: colors.green,
        warning: colors.orange,
        error: colors.red,
        info: colors.blue,
        headline1: "#000000",
        headline2: "#000000",
        headline3: "#000000",
        headline4: "#000000",
        headline5: "#000000",
        headline6: "#000000",
        subheader: "#000000",
        product_name: "#000000",
        product_description: "#000000",
        product_card: "#FFFFFF",
      },
    },
  },

  icons: {
    iconfont: "mdi" || "md" || "fa" || "fal",
  },
});
